import React, {useEffect, useState} from 'react';

/**
 * Fabric UI
 */
import {
  PrimaryButton,
  DefaultButton
} from '@fluentui/react/lib/Button';
import {TooltipHost} from '@fluentui/react/lib/Tooltip';
import {DirectionalHint} from '@fluentui/react/lib/Callout';
import {Dialog, DialogFooter} from '@fluentui/react/lib/Dialog';
import {Checkbox} from '@fluentui/react/lib/Checkbox';
import {Spinner, SpinnerSize} from '@fluentui/react/lib/Spinner';
import {isEqual} from 'lodash';

const CommunityToolsComponent = (props: any) => {
  const {
    community,
    profile,
    constants,
    showManagementTools,
    favouriteCommunities,
    requestsActionCreators,
    inviteMembersActionCreators,
    communityActionCreators,
    membersActionCreators,
    CommunityEditModal,
  } = props;
  const {isExporting} = community;

  const [hideDeleteDialog, setHideDeleteDialog] = useState<boolean>(true);
  const [hideLeaveDialog, setHideLeaveDialog] = useState<boolean>(true);
  const [isAllowDelete, setIsAllowDelete] = useState(false);
  const [/*isAllowLeave*/, setIsAllowLeave] = useState(false);
  const [isFavouriteFill, setIsFavouriteFill] = useState(false);

  useEffect(() => {
    if ( isFavouriteFill !== community?.isFavourite )
      setIsFavouriteFill(community?.isFavourite);
  }, [community]);

  useEffect(() => {
    if ( isFavouriteFill !== community?.isFavourite )
      setIsFavouriteFill(community?.isFavourite);
  }, [community?.isFavourite]);

  const openInTeams = () => {
    window.open(community.url, '_blank');
  };

  const openInSharePoint = () => {
    window.open(community.sharePointUrl, '_blank');
  };

  const leaveCommunity = () => {
    membersActionCreators.requestLeaveMember(
      community.communityId,
      profile.id,
      !showManagementTools,
      community.displayName,
    );

    closeLeaveDialog();
  };

  const requestToJoin = () => {
    requestsActionCreators.startJoinMember(
      community.communityId,
      community.communityType,
      !showManagementTools
    );

    if (community.communityType === 'private') {
      communityActionCreators.closeCommunityPanel();
    }
  };

  const inviteMembers = () => {
    communityActionCreators.closeCommunityPanel();
    inviteMembersActionCreators.startEditInviteMembers(
      community.communityId
    );
  };

  const exportCommunity = () => {
    communityActionCreators.exportCommunityMemberCsv(
      community.communityId
    );
    setTimeout(communityActionCreators.closeCommunityPanel, 1000);
  };

  const exportCommunityInvites = () => {
    communityActionCreators.closeCommunityPanel();
    communityActionCreators.exportCommunityInvitesCsv(
      community.communityId
    );
  };

  const manageCommunity = () => {
    communityActionCreators.closeCommunityPanel();
    communityActionCreators.startEditManage(community);
  };

  const editCommunity = () => {
    // communityActionCreators.closeCommunityPanel();
    communityActionCreators.startEditCommunity(community);
  };

  const closeCommunity = () => {
    communityActionCreators.closeCommunityPanel();
    closeDeleteDialog();
    communityActionCreators.requestCloseCommunity(
      community.communityId
    );
  };

  const toggleFavourite = async (event) => {
    if (!favouriteCommunities) {
      await communityActionCreators.requestFetchCommunities();
    }

    await communityActionCreators.toggleFavourite(community);
  };

  const isFavourite = () => {
    const favourites = favouriteCommunities;
    let isFavourite = false;

    favourites.forEach((favourite) => {
      if (favourite.communityId === community.communityId) {
        isFavourite = true;
        return;
      }
    });

    return isFavourite;
  }

  const showDeleteDialog = () => {
    setHideDeleteDialog(false);
  };

  const closeDeleteDialog = () => {
    setHideDeleteDialog(true);
    setIsAllowDelete(false);
  };

  const showLeaveDialog = () => {
    setHideLeaveDialog(false);
  };

  const closeLeaveDialog = () => {
    setHideLeaveDialog(true);
    setIsAllowLeave(false);
  };

  const onCheckboxChange = (ev, isChecked) => {
    setIsAllowLeave(isChecked);
  };

  return (
    <div className='govTeams-communityTools'>
      {community && community.isCreated ? (
        <div>
          {!!CommunityEditModal && <CommunityEditModal /> }
          <ul className='toolsList'>
            {community.isMember &&
              community.url &&
              community.iconPreferenceId !== 3 && (
                <li className='toolsList-itemTeams'>
                  <TooltipHost
                    content={constants.TEAMS}
                    directionalHint={DirectionalHint.leftTopEdge}
                  >
                    <DefaultButton
                      iconProps={{iconName: 'TeamsLogo'}}
                      text='Launch Teams'
                      ariaLabel='Launch community in Teams'
                      onClick={openInTeams}
                      disabled={!community.isCreated}
                    />
                  </TooltipHost>
                </li>
              )}
            {((community.isMember &&
                community.sharePointUrl &&
                community.iconPreferenceId !== 2) ||
              (!profile.isGuest &&
                !community.isMember &&
                community.communityType === 'Open' &&
                community.sharePointUrl)) && (
              <li className='toolsList-itemSharePoint'>
                <TooltipHost
                  content={constants.SHAREPOINT}
                  directionalHint={DirectionalHint.leftTopEdge}
                >
                  <DefaultButton
                    iconProps={{iconName: 'SharePointLogo'}}
                    text='Launch in SharePoint'
                    ariaLabel={constants.SHAREPOINT}
                    onClick={openInSharePoint}
                    disabled={
                      !community.isCreated || !community.sharePointUrl
                    }
                  />
                </TooltipHost>
              </li>
            )}
            {community.isMember && !community.isOwner && (
              <li className='toolsList-itemLeave'>
                <TooltipHost
                  content={constants.LEAVE}
                  directionalHint={DirectionalHint.leftTopEdge}
                >
                  <DefaultButton
                    iconProps={{iconName: 'Leave'}}
                    text='Leave community'
                    ariaLabel={constants.LEAVE}
                    onClick={showLeaveDialog}
                    disabled={!community.isCreated}
                  />
                </TooltipHost>
                <Dialog
                  key='dialog-leave'
                  hidden={hideLeaveDialog}
                  onDismiss={closeLeaveDialog}
                  dialogContentProps={{
                    title: `Leave '${community.displayName}'`
                  }}
                  modalProps={{
                    isBlocking: true,
                    isDarkOverlay: true,
                    className: 'govTeams-dialog'
                  }}
                >
                  <p>{constants.LEAVE_MESSAGE}</p>

                  <DialogFooter>
                    <DefaultButton
                      onClick={closeLeaveDialog}
                      text='Cancel'
                    />
                    <PrimaryButton
                      onClick={leaveCommunity}
                      text={constants.LEAVE}
                    />
                  </DialogFooter>
                </Dialog>
              </li>
            )}
            {community.isMember && community.isOwner && (
              <li className='toolsList-itemInvite'>
                <TooltipHost
                  content={constants.INVITE}
                  directionalHint={DirectionalHint.leftTopEdge}
                >
                  <DefaultButton
                    iconProps={{iconName: 'PeopleAdd'}}
                    text='Invite members'
                    ariaLabel={constants.INVITE}
                    onClick={inviteMembers}
                    disabled={!community.isCreated}
                  />
                </TooltipHost>
              </li>
            )}
            {community.isOwner && [
              <li key='edit' className='toolsList-itemEdit'>
                <TooltipHost
                  content={constants.EDIT}
                  directionalHint={DirectionalHint.leftTopEdge}
                >
                  <DefaultButton
                    iconProps={{iconName: 'Edit'}}
                    text='Edit community'
                    ariaLabel={constants.EDIT}
                    onClick={editCommunity}
                    disabled={!community.isCreated}
                  />
                </TooltipHost>
              </li>,
              <li key='close' className='toolsList-itemClose'>
                <TooltipHost
                  content={constants.CLOSE}
                  directionalHint={DirectionalHint.leftTopEdge}
                >
                  <DefaultButton
                    iconProps={{iconName: 'Delete'}}
                    text='Close community'
                    ariaLabel={constants.CLOSE}
                    disabled={!community.isCreated}
                    onClick={showDeleteDialog}
                  />
                </TooltipHost>
              </li>,
              <li key='export' className='toolsList-itemExport display-flex'>
                <TooltipHost
                  content={constants.EXPORT}
                  directionalHint={DirectionalHint.leftTopEdge}
                >
                  <DefaultButton
                    iconProps={{iconName: 'Download'}}
                    text='Export members'
                    ariaLabel={constants.EXPORT}
                    disabled={!community.isCreated || isExporting}
                    onClick={exportCommunity}
                  />
                </TooltipHost>
                {isExporting && (
                  <Spinner size={SpinnerSize.small}/>
                )}
              </li>,
              <li key='exportInvites' className='toolsList-itemExportInvites'>
                <TooltipHost
                  content={constants.EXPORT_INVITES}
                  directionalHint={DirectionalHint.leftTopEdge}
                >
                  <DefaultButton
                    iconProps={{iconName: 'Download'}}
                    text='Export pending invitations'
                    ariaLabel={constants.EXPORT_INVITES}
                    disabled={!community.isCreated}
                    onClick={exportCommunityInvites}
                  />
                </TooltipHost>
              </li>,
              <Dialog
                key='dialog'
                hidden={hideDeleteDialog}
                onDismiss={closeDeleteDialog}
                dialogContentProps={{
                  title:
                    "Delete '" +
                    community.displayName +
                    "' community"
                }}
                modalProps={{
                  isBlocking: true,
                  isDarkOverlay: true,
                  className: 'govTeams-dialog'
                }}
              >
                <p>
                  {constants.POPUP_COMMUNITY_CLOSE.replace(
                    '%DISPLAYNAME%',
                    community.displayName
                  )}
                </p>
                <Checkbox
                  label='I understand that everything will be deleted.'
                  onChange={onCheckboxChange}
                />
                <DialogFooter>
                  <DefaultButton
                    onClick={closeDeleteDialog}
                    text='Cancel'
                  />
                  <PrimaryButton
                    onClick={closeCommunity}
                    disabled={!isAllowDelete}
                    text='Delete community'
                  />
                </DialogFooter>
              </Dialog>
            ]}
            {!community.isMember && (
              <li className='toolsList-itemJoin'>
                <TooltipHost
                  content={
                    community.communityType === 'Open'
                      ? constants.JOIN
                      : constants.REQUEST
                  }
                  directionalHint={DirectionalHint.leftTopEdge}
                >
                  <DefaultButton
                    iconProps={{iconName: 'AddFriend'}}
                    text={
                      !profile.isGuest &&
                      community.communityType === 'Open'
                        ? 'Join this community'
                        : 'Request to join this community'
                    }
                    ariaLabel={
                      community.communityType === 'Open'
                        ? constants.JOIN
                        : constants.REQUEST
                    }
                    onClick={requestToJoin}
                    disabled={!community.isCreated}
                  />
                </TooltipHost>
              </li>
            )}
            {community.isMember && (
              <li className='toolsList-itemFav'>
                <TooltipHost
                  content={
                    isFavouriteFill
                      ? 'Remove favourite'
                      : 'Favourite community'
                  }
                  directionalHint={DirectionalHint.leftTopEdge}
                >
                  <DefaultButton
                    iconProps={{
                      iconName: isFavouriteFill
                        ? 'FavoriteStarFill'
                        : 'FavoriteStar'
                    }}
                    text={
                      isFavouriteFill
                        ? 'Remove favourite'
                        : 'Favourite community'
                    }
                    ariaLabel={
                      isFavouriteFill
                        ? 'Remove fvourite'
                        : 'Favourite community'
                    }
                    onClick={toggleFavourite}
                    disabled={!community.isCreated}
                  />
                </TooltipHost>
              </li>
            )}
          </ul>
          {showManagementTools && (
            <div>
              <hr/>
              <PrimaryButton
                text='View community details and membership'
                ariaLabel='View community details and membership'
                primary={true}
                onClick={manageCommunity}
                styles={{
                  root: {
                    borderRadius: 6
                  }
                }}
              />
            </div>
          )}
        </div>
      ) : (
        <p>{constants.PROCESSING}</p>
      )}
    </div>
  );
};

export default CommunityToolsComponent;